module.exports = __webpack_public_path__ + "img/syr.64f0d2d7.svg";